import type { FaireProductEntity } from "../../entity_types/product";

export const p_j8bcevr3vt: FaireProductEntity = {
  token: "p_j8bcevr3vt",
  type: "product",
  name: "Thank You Flower Bouquet Card | Botanical Plant Lover Greeting Cards",
  brandToken: "b_nskhtecdp8",
  brandName: "Serafine Art and Design",
  imageUrl:
    "https://cdn.faire.com/fastly/a2662779d3ec44239bf750b124782736752ed60ecb7146b7eb0d9d8de1e7972d.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/069769791a45f319cf677e781e3ed0beecd8a94a91d2d37141472825e2b76a3e.jpeg",
    "https://cdn.faire.com/fastly/4c4da6a9ffad6e7e45966f639e1a299be494957fdad8e627cfb03f4513178aa4.jpeg",
    "https://cdn.faire.com/fastly/97ea5a4f4c8c46426d0328b7906bcb6b3c7021c637268f4382f7bfcf575f1b4f.jpeg",
    "https://cdn.faire.com/fastly/092bb181fcba8dc27ff91d56796727b6076e1ff5f91fca077a0f8868fe7577f0.jpeg",
    "https://cdn.faire.com/fastly/21da205a5c986c49618790b7981f46197bb7608b8cb3516eb5b8ccb312b58551.jpeg",
    "https://cdn.faire.com/fastly/13109d1ad021ae978f96b80be2080e2bd52b221ae0e81f56a72af611d8e26f7d.jpeg",
  ],
  priceDollars: 2.74,
  description:
    "Hand-illustrated greeting cards with cozy, playful designs for every occasion! Each card is professionally printed on thick cardstock with a smooth matte finish and comes with a matching envelope. A perfect checkout add-on or gift shop staple for stationery lovers.\n\nFeatures:\n- Standard A2 (4.25”x5.5”) size\n- Each card comes with one white A2 envelope\n- Glossy outer finish\n- Blank inside\n- Handmade, vigorous quality standards\n- 110lb cardstock\n- White back with company logo\n- Comes prepackaged in a cellophane sleeve",
  tags: [],
  msrpDollars: 5.49,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:50:07.301Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
